




import { defineComponent, reactive } from '@vue/composition-api';
import { EntityType } from '@/store/entityModules/types';
import EntityTable from '@/components/common/EntityTable.vue';

const Component = defineComponent({
  name: 'ColorGroupsTable',

  components: {
    EntityTable,
  },

  setup() {
    const entityType = EntityType.COLOR_GROUP;

    const state = reactive({
      headers: [
        { text: 'Name', value: 'name', sortable: true, searchable: true },
        { text: 'Colors amount', value: 'totalColors', align: 'center', sortable: true },
        { text: 'Details', value: 'actions', align: 'right', sortable: false },
      ],
    });

    return {
      entityType,
      state,
    };
  },
});
export default Component;
